const CART_CHAT_HIDE_STYLE_ATTR = 'data-cart-checkout-chat-hide';

function setShopifyChatHiddenForCheckout(hidden) {
  document.querySelectorAll('shopify-chat').forEach((chat) => {
    const root = chat.shadowRoot;
    if (!root) return;
    let style = root.querySelector(`style[${CART_CHAT_HIDE_STYLE_ATTR}]`);
    if (!style) {
      style = document.createElement('style');
      style.setAttribute(CART_CHAT_HIDE_STYLE_ATTR, '1');
      root.appendChild(style);
    }
    style.textContent = hidden
      ? '.activator-nudge{display:none!important;visibility:hidden!important;pointer-events:none!important;}'
      : '';
  });
}

function syncFloatingWidgetsForCheckout() {
  const drawerOpen = document.body.classList.contains('cart-drawer-open');
  const onCartPage = document.body.classList.contains('template-cart');
  const isMobile = window.matchMedia('(max-width: 749px)').matches;
  setShopifyChatHiddenForCheckout(drawerOpen || (onCartPage && isMobile));
}

function ensureCheckoutChatHideObserver() {
  if (window.__cartCheckoutChatHideObserver) return;
  window.__cartCheckoutChatHideObserver = new MutationObserver(() => syncFloatingWidgetsForCheckout());
  window.__cartCheckoutChatHideObserver.observe(document.documentElement, { childList: true, subtree: true });
  [500, 1500, 3000].forEach((ms) => setTimeout(syncFloatingWidgetsForCheckout, ms));
  window.matchMedia('(max-width: 749px)').addEventListener('change', syncFloatingWidgetsForCheckout);
}

function refreshCartDrawerUpsells() {
  document.querySelectorAll('cart-drawer-upsells').forEach((el) => {
    if (typeof el.loadRecommendations === 'function') {
      el.loadRecommendations();
    }
  });
}

window.refreshCartDrawerUpsells = refreshCartDrawerUpsells;

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay')?.addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    ensureCheckoutChatHideObserver();
    syncFloatingWidgetsForCheckout();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden', 'cart-drawer-open');
    syncFloatingWidgetsForCheckout();
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden', 'cart-drawer-open');
    syncFloatingWidgetsForCheckout();
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner')?.classList.remove('is-empty');
    this.classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement || !parsedState.sections?.[section.id]) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    // Paint skeleton + start fetch before open so first-add never shows a blank upsells gap
    this.querySelectorAll('cart-drawer-upsells').forEach((el) => {
      el.hidden = false;
      if (typeof el.showSkeleton === 'function') el.showSkeleton();
      if (typeof el.loadRecommendations === 'function') el.loadRecommendations();
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay')?.addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

class CartDrawerUpsells extends HTMLElement {
  connectedCallback() {
    if (this.dataset.bound === 'true') {
      this.loadRecommendations();
      return;
    }
    this.dataset.bound = 'true';
    this.addEventListener('click', this.onClick.bind(this));
    this.loadRecommendations();
  }

  get listEl() {
    return this.querySelector('[data-upsells-list]');
  }

  get isStatic() {
    return this.dataset.static === 'true';
  }

  showSkeleton() {
    if (this.isStatic) return;
    const list = this.listEl;
    if (!list) return;
    list.innerHTML = `
      <div class="cart-drawer-upsells__skeleton" aria-hidden="true">
        <div class="cart-drawer-upsells__skeleton-row"></div>
        <div class="cart-drawer-upsells__skeleton-row"></div>
        <div class="cart-drawer-upsells__skeleton-row"></div>
      </div>
    `;
  }

  loadRecommendations() {
    // Empty-cart server-rendered upsells: keep Liquid HTML, no recommendations fetch
    if (this.isStatic || (!this.dataset.url && this.querySelector('.cart-drawer-upsell'))) {
      this.hidden = false;
      this.removeAttribute('aria-busy');
      return;
    }

    const productId = this.dataset.productId;
    const baseUrl = this.dataset.url;
    if (!productId || !baseUrl) {
      this.hidden = true;
      this.removeAttribute('aria-busy');
      return;
    }

    // Avoid duplicate in-flight fetches for the same product
    if (this._upsellsLoadingId === productId && this._upsellsAbort) {
      return;
    }
    if (this._upsellsAbort) {
      this._upsellsAbort.abort();
    }
    this._upsellsAbort = new AbortController();
    this._upsellsLoadingId = productId;

    this.hidden = false;
    this.setAttribute('aria-busy', 'true');
    this.showSkeleton();

    const url = `${baseUrl}${baseUrl.includes('?') ? '&' : '?'}product_id=${productId}`;

    fetch(url, { signal: this._upsellsAbort.signal })
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const items = html.querySelector('.cart-drawer-upsells__items');
        const list = this.listEl;
        if (!list) return;

        if (items && items.children.length) {
          list.innerHTML = items.outerHTML;
          this.hidden = false;
        } else {
          // Only hide when response is empty — keep skeleton until then
          list.innerHTML = '';
          this.hidden = true;
        }
      })
      .catch((e) => {
        if (e?.name === 'AbortError') return;
        console.error(e);
        this.hidden = true;
      })
      .finally(() => {
        if (this._upsellsLoadingId === productId) {
          this._upsellsLoadingId = null;
          this.removeAttribute('aria-busy');
        }
      });
  }

  onClick(event) {
    const button = event.target.closest('.cart-drawer-upsell__add');
    if (!button || button.disabled) return;
    event.preventDefault();
    this.addUpsell(button);
  }

  setButtonLoading(button, loading) {
    button.disabled = loading;
    button.setAttribute('aria-busy', loading ? 'true' : 'false');
    button.classList.toggle('is-loading', loading);
    const label = button.querySelector('.cart-drawer-upsell__add-label');
    const spinner = button.querySelector('.cart-drawer-upsell__add-spinner');
    if (label) label.hidden = loading;
    if (spinner) spinner.hidden = !loading;
  }

  addUpsell(button) {
    const variantId = button.dataset.variantId;
    if (!variantId) return;

    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;

    this.setButtonLoading(button, true);

    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');
    formData.append(
      'sections',
      cartDrawer
        .getSectionsToRender()
        .map((section) => section.id)
        .join(',')
    );
    formData.append('sections_url', window.location.pathname);

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = formData;

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          console.error(response.description || response.message);
          this.setButtonLoading(button, false);
          return;
        }

        cartDrawer.classList.remove('is-empty');
        cartDrawer.renderContents(response);
      })
      .catch((e) => {
        console.error(e);
        this.setButtonLoading(button, false);
      });
  }
}

customElements.define('cart-drawer-upsells', CartDrawerUpsells);
